import Image from "next/image";

/** Static agent mark for finished chat rows. For loading, use `AgentThinking` / `AiLoader` only. */
export function AgentAvatar() {
  return (
    <span className="mt-0.5 flex size-8 shrink-0 items-center justify-center rounded-full border border-primary/20 bg-[linear-gradient(135deg,var(--primary)_0%,color-mix(in_oklch,var(--primary)_75%,white)_100%)] shadow-sm">
      <Image src="/figma-assets/aunix-spark.svg" alt="" width={16} height={16} />
    </span>
  );
}
